import { useState, useEffect, useCallback } from "react";
import { ethers } from "ethers";

import { useUser } from "../context/UserContext";

        import EthereumProvider from "@walletconnect/ethereum-provider";
        
        const useWalletConnect = () => {
          const [provider, setProvider] = useState(null);
          const [signer, setSigner] = useState(null);
          const [account, setAccount] = useState(null);
          const [chainId, setChainId] = useState(null);
          const [loading, setLoading] = useState(true);

          
              const { logout} = useUser();
        
          const connectBrowserWallet = useCallback(async () => {
            if (!window.ethereum) {
              alert("MetaMask not detected. Please install it.");
              return;
            }
            setLoading(true)
            const bscMainnetParams = {
              chainId: '0x38', // 56 in hex
              chainName: 'Binance Smart Chain Mainnet',
              nativeCurrency: {
                name: 'BNB',
                symbol: 'BNB',
                decimals: 18,
              },
              rpcUrls: ['https://bsc-dataseed.binance.org/'],
              blockExplorerUrls: ['https://bscscan.com'],
            };
          
            try {
              // 🟡 Attempt to switch to BSC Mainnet (or add if not exists)
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: bscMainnetParams.chainId }],
              });
            } catch (switchError) {
              // If the chain is not added yet, add it
              if (switchError.code === 4902) {
                try {
                  await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [bscMainnetParams],
                  });
                } catch (addError) {
                  console.error("User rejected adding BSC:", addError);
                  return;
                }
              } else {
                console.error("Switch error:", switchError);
                return;
              }
            }
          
            try {
              // ✅ Now connect wallet
              await window.ethereum.request({ method: 'eth_requestAccounts' });
          
              const browserProvider = new ethers.BrowserProvider(window.ethereum);
              const browserSigner = await browserProvider.getSigner();
              const accounts = await browserProvider.listAccounts();
              const network = await browserProvider.getNetwork();
          
              setProvider(browserProvider);
              setSigner(browserSigner);
              setAccount(accounts[0]);
              setChainId(network.chainId);
              localStorage.setItem("walletConnectionType", "browser");
          
              window.ethereum.on('accountsChanged', async (accounts) => {
                if (accounts.length === 0) {
                  disconnectWallet(); // Optional: logout on disconnect
                } else {
                  const browserProvider = new ethers.BrowserProvider(window.ethereum);
                  const browserSigner = await browserProvider.getSigner();
                  const network = await browserProvider.getNetwork();
              
                  setProvider(browserProvider);
                  setSigner(browserSigner);
                  setAccount(accounts[0]);
                  setChainId(network.chainId);
                }
              });
              
              window.ethereum.on('chainChanged', async () => {
                const browserProvider = new ethers.BrowserProvider(window.ethereum);
                const network = await browserProvider.getNetwork();
                setChainId(network.chainId);
                
            setLoading(false)
              });
            } catch (connectError) {
              setLoading(false)
              console.error("Failed to connect wallet:", connectError);
            }
          }, []);
        
         
                
                const connectWalletConnect = useCallback(async () => {
                  setLoading(true)
                  try {
                    const wcProvider = await EthereumProvider.init({
                      projectId: "9f1c3c10d43976445e8045f208226bdc", 
                      chains: [56],
                      rpcMap: {
                        56: "https://bsc-dataseed.binance.org"
                      },
                      showQrModal: true,
                    });
                
                    await wcProvider.enable(); // triggers QR scan
                
                    const ethersProvider = new ethers.BrowserProvider(wcProvider);
                    const userSigner = await ethersProvider.getSigner();
                    const network = await ethersProvider.getNetwork();
                
                    const userAccount = wcProvider.accounts[0]; // ✅ use directly
                
                    setProvider(ethersProvider);
                    setSigner(userSigner);
                    setAccount(userAccount);
                    setChainId(network.chainId);
                    localStorage.setItem("walletConnectionType", "walletconnect");
                    setLoading(false)
                  } catch (error) {
                    setLoading(false)
                    console.error("WalletConnect connection error:", error);
                  }
                }, []);

                

          const disconnectWallet = useCallback(async () => {
            if (provider?.provider?.disconnect) {
              await provider.provider.disconnect();
            }
            localStorage.removeItem("walletConnectionType");
            setProvider(null);
            setSigner(null);
            setAccount(null);
            setChainId(null);
            logout()
          }, [provider]);
        
          // Auto-reconnect logic
          useEffect(() => {
            const reconnect = async () => {

              setLoading(true)
              const type = localStorage.getItem("walletConnectionType");
              if (type === "browser") {
                await connectBrowserWallet();
              } else if (type === "walletconnect") {
                await connectWalletConnect();
              }
              setLoading(false);
            };
            reconnect();
          }, [connectBrowserWallet, connectWalletConnect]);
        
          return {
            provider,
            signer,
            account,
            chainId,
            loading,
            connectBrowserWallet,
            connectWalletConnect,
            disconnectWallet,
          };
        };
        
        export default useWalletConnect;
        